export default from './post-create-page';



// WEBPACK FOOTER //
// ./app/containers/post-create-page/index.js